<h2 mat-dialog-title class="text-center">Añadir linea</h2>
<mat-dialog-content class="text-center">
  <div [formGroup]="lineaForm"   style="padding: 16px">
    <div class="row">
      <div class="col-12">
        <label class="form-label">Observaciones</label>
        <textarea class="form-control" formControlName="observacion"></textarea>
      </div>

    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions  >
  <div class="row">
    <div class="col-1"></div>
    <div class="col-10">
      <button mat-button matDialogClose  class="aceptar float-left" >Cerrar</button>
      <button mat-button [mat-dialog-close]="lineaForm" class="aceptar"  [disabled]="!lineaForm.valid">Guardar</button>
    </div>
    <div class="col-1"></div>
  </div>
</mat-dialog-actions>
